import React from 'react';
import { ProfileContainer } from 'pages/addprofile/AddProfile.style';
import { useNavigate, useParams } from 'react-router-dom';
import PostTab from 'pages/profile/Post';
import { CloseIcon, Tab } from 'components';
import PostList from 'pages/home/PostList';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const TabnameRenders = (tab) => {
  if (tab === 0) {
    return 'post';
  } else if (tab === 1) {
    return 'likes';
  } else if (tab === 2) {
    return 'comments';
  } else if (tab === 3) {
    return 'saved';
  }
};

const AddProfile = () => {
  const navigate = useNavigate();
  const { tabname } = useParams();
  const { t } = useTranslation();

  const tablist = [
    {
      label: t('profile.Post'),
      value: 0,
      content: <PostTab />,
    },
    {
      label: t('profile.Likes'),
      value: 1,
      content: <PostList view="likes" />,
    },
    {
      label: t('profile.Comments'),
      value: 2,
      content: <PostList view="comments" />,
    },
    {
      label: t('profile.Saved'),
      value: 3,
      content: <PostList view="save" />,
    },
  ];

  const TabChange = (name) => {
    navigate(`../home/${TabnameRenders(name)}`, { replace: true });
  };

  const TabValues = () => {
    if (tabname === 'post') {
      return 0;
    } else if (tabname === 'likes') {
      return 1;
    } else if (tabname === 'comments') {
      return 2;
    } else if (tabname === 'saved') {
      return 3;
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {tabname === 'likes'
            ? 'Liked Posts | WafyNet - Posts You Liked'
            : tabname === 'comments'
            ? 'Comments | WafyNet - Posts You Commented'
            : tabname === 'saved'
            ? 'Saved Posts | WafyNet - Your Saved Collections'
            : 'My Posts | WafyNet - View Your Shared Posts'}
        </title>
        <meta
          name="description"
          content={
            tabname === 'likes'
              ? 'Explore the posts you liked on WafyNet.'
              : tabname === 'comments'
              ? 'View posts you commented on and shared thoughts.'
              : tabname === 'saved'
              ? 'Find and manage posts you saved for later on WafyNet.'
              : 'View and manage your posts shared on WafyNet.'
          }
        />
      </Helmet>
      <ProfileContainer>
        <div className="profile-header">
          <CloseIcon iconType={'back'} onClick={() => navigate(-1)} />
          <div className="user-name">{t('HomePage.Back')}</div>
        </div>
        <Tab
          tabList={tablist}
          handleTabChange={(e) => TabChange(e)}
          callbackTabIndex={() => TabValues()}
        />
      </ProfileContainer>
    </>
  );
};
export default AddProfile;
